import PropTypes from "prop-types";

export default function Card({ title, action, children, className = "" }) {
  return (
    <section className={`rounded-xl bg-white p-4 shadow-card md:p-5 ${className}`} >
      {(title || action) && (
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-lg font-semibold text-text-900 md:text-xl">{title}</h1>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

Card.propTypes = {
  title: PropTypes.node,
  action: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};
